import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { useTransactionRefundStatus } from "api/clients/useTransactionRefundStatus";
import type { RefundModalEvent } from "./refundModal.events";
import type { TransactionRefundModalState } from "./refundModal.state";

/** Poll for final refund status if the refund happened asynchronously. */
export function useRefundPolling(
    patientId: number,
    state: TransactionRefundModalState,
    dispatch: React.Dispatch<RefundModalEvent>,
) {
    const { data: refundStatusData } = useTransactionRefundStatus(state.type === "refund-polling" ? state : null);

    const queryClient = useQueryClient();

    useEffect(() => {
        if (refundStatusData) {
            dispatch({ type: "refund-result", ...refundStatusData });

            // re-invalidate queries from useTransactionRefund now that we have final status
            void queryClient.invalidateQueries({
                queryKey: ["transactionHistory", patientId],
            });
            void queryClient.invalidateQueries({
                queryKey: ["paymentReport"],
            });
        }
    }, [patientId, queryClient, refundStatusData, dispatch]);
}
